module.exports = __webpack_public_path__ + "img/Group 1140four.cb01e411.png";